<template>
  <div>
    <div class="location">
      当前位置：
      <router-link :to="{ path: '/' }" class="a">首页</router-link
      >&nbsp;&gt;&nbsp;
      <router-link
        :to="{
          path: '/allReports',
          query: { id: currentId, idname: currentFieldname },
        }"
        class="a"
        >{{ currentFieldname }}</router-link
      >&nbsp;&gt;&nbsp;
      <a class="a" href="javascript:;">{{ currentReportUid }}</a>
    </div>
    <ul class="qb_main_ul">
      <li v-for="item in docsData" :key="item.code" class="clearfix">
        <a
          :href="
            indexLinkURL +
            '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
            item.chnid +
            '&leafid=' +
            item.leafid +
            '&docid=' +
            item.code.substring(4, item.code.length) +
            '&uid=' +
            item.uid +
            '&version=dReport'
          "
          target="_blank"
          class="fl"
        >
          <span class="d_icon">·</span>
          <span>{{ item.title }}</span>
        </a>
        <span class="fr time">{{ item.deliveddate }}</span>
      </li>
    </ul>

    <div class="y-pagination" >
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :page-size="29"
        :current-page="currentPage"
        layout="prev, pager, next, jumper, total"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { api } from "@/pages/index/require/api.js";
export default {
  data() {
    return {
      currentReportUid: "",
      currentId: "",
      currentFieldname: "",
      docsData: {},
      currentPage: 1,
      total: 0,
      indexLinkURL: window.indexLinkURL,
    };
  },
  created() {
    this.currentReportUid = this.$route.query.uid;
    this.$route.query.id === undefined
      ? (this.currentId = "90")
      : (this.currentId = this.$route.query.id);
    this.currentFieldname = this.$route.query.idname;
    this.loadDocs();
  },
  watch: {
    $route() {
      this.currentReportUid = this.$route.query.uid;
      this.$route.query.id === undefined
        ? (this.currentId = "90")
        : (this.currentId = this.$route.query.id);
      this.currentFieldname = this.$route.query.idname;
    },
  },
  methods: {
    async loadDocs() {
      const { code, data } = await api.get("/indexController/getIndexDocs", {
        uid: this.currentId,
        reportType: this.currentReportUid,
        currpage: this.currentPage,
        pagesize: 29,
        isIndexSearch: false,
        time: new Date().getTime(),
      });
      this.docsData = {};
      if (code === 0) {
        if (this.currentReportUid === "周评") {
          this.docsData = data.weekreport.data;
          this.total = data.weekreport.totlalCount;
        } else if (this.currentReportUid === "月度报告") {
          this.docsData = data.monthreport.data;
          this.total = data.monthreport.totlalCount;
        } else if (this.currentReportUid === "季度报告") {
          this.docsData = data.quarterreport.data;
          this.total = data.quarterreport.totlalCount;
        } else if (this.currentReportUid === "热点报告") {
          this.docsData = data.hotreport.data;
          this.total = data.hotreport.totlalCount;
        } else if (this.currentReportUid === "年度报告") {
          this.docsData = data.yearreport.data;
          this.total = data.yearreport.totlalCount;
        }
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadDocs();
    },
  },
};
</script>

<style lang='less' scoped>
.qb_main_ul {
  margin-left: 11px;
  margin-top: 15px;
  li {
    line-height: 30px;
    a {
      font-size: 15px;
      color: #333;
      display: block;
      width: 80%;
      overflow: hidden;
      -o-text-overflow: ellipsis;
      text-overflow: ellipsis;
      white-space: nowrap;
      .d_icon {
        font-size: 14px;
        font-weight: bold;
        color: #caccce;
        padding-right: 5px;
      }
    }
    .time {
      color: #666;
    }
  }
  li:nth-child(6n) {
    margin-top: 25px;
  }
  li:hover a,
  li:hover .time {
    color: #0770b9;
  }
}
.y-pagination {
  font-family: "microsoft yahei";
  font-size: 12px;
  margin: 30px 0;
  padding-bottom: 20px;
}
/deep/.el-pagination__jump {
  margin: 0 24px;
}
</style>